import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SdTaskAssignmentUserInfo } from "@api/web-api-client";

export interface ITaskAssignmentsSliceState {
    profilePictures: SdTaskAssignmentUserInfo[];
}

const initialState: ITaskAssignmentsSliceState = {
    profilePictures: [],
};

export const taskAssignmentsSlice = createSlice({
    name: "taskAssignments",
    initialState: initialState,
    reducers: {
        addAssignmentsProfilePictures: (
            state,
            action: PayloadAction<SdTaskAssignmentUserInfo[]>,
        ) => {
            state.profilePictures = [
                ...state.profilePictures,
                ...action.payload,
            ];
        },
    },
});

export const { addAssignmentsProfilePictures } = taskAssignmentsSlice.actions;

export default taskAssignmentsSlice.reducer;
